import { useEffect, useRef, useState } from "react";

export const useDeferredEffect = (callback: () => void, deps: any[]) => {
   const hasRendered = useRef(false);
   const [firstRender, setFirstRender] = useState(false);
   useEffect(() => {
      if (hasRendered.current && firstRender) {
         callback();
      } else {
         hasRendered.current = true;
         setFirstRender(true);
      }
   }, [...deps, firstRender]);
};
